"use client";
import { jsx, Fragment } from "react/jsx-runtime";
import { isBD } from "../../../../utils/businessType.lib.js";
import { useCriteo } from "../../../../utils/criteo/CriteoProvider.js";
import { findCriteoPlacement } from "../../../../utils/criteo/utils.js";
import { Skeleton, Link } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
import "../../../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../../Chrome/BrowseContext/hook.js";
import { Observable } from "../ProductTileCarousel/Observable.js";
import GenericImageHandler from "../../../Util/GenericImageHandler.js";
import { useCheckScreen } from "../../../../hooks/useCheckScreen/index.js";
import { SUPPORTED_IN_GRID_FORMATS } from "./constants.js";
import { getLocalizedCriteoRenderingValue, useCriteoAnalytics } from "./utils.js";
import { StyledInGridBannerMediaContainer } from "./styles.js";
const COMPONENT_NAME = "CriteoInGridBanner";
function CriteoInGridBanner(props) {
  const { placementName, sx = {}, isCategoryPage, locale } = props;
  const { isMobile } = useCheckScreen();
  const { thirdPartyInfo } = useBrowseContext();
  const { consentManagement } = thirdPartyInfo;
  const { isTargetingEnabled } = consentManagement || {};
  const {
    searchPageData,
    searchPageError,
    isLoadingCriteoData,
    isTargetingEnabled: isCriteoTargetingEnabled
  } = useCriteo();
  const basePlacementKey = isCategoryPage ? "viewCategory" : isBD() ? "viewSearchResult" : "viewSearchResults";
  const placementKey = `${basePlacementKey}_API_${isMobile ? "mobile" : "desktop"}-${placementName}`;
  const placement = findCriteoPlacement(
    placementKey,
    searchPageData == null ? void 0 : searchPageData.placements
  );
  const analytics = useCriteoAnalytics({ placement });
  if (!isTargetingEnabled || !isCriteoTargetingEnabled) {
    return null;
  }
  const imageHeight = isMobile ? 150 : 120;
  if (isLoadingCriteoData) {
    return /* @__PURE__ */ jsx(Skeleton, { height: imageHeight, variant: "rectangular" });
  }
  if (searchPageError) {
    console.error("Error loading search page data", searchPageError);
    return;
  }
  if (!placement) {
    return;
  }
  if (!SUPPORTED_IN_GRID_FORMATS.includes(placement == null ? void 0 : placement.format)) {
    console.error(
      `Criteo InGridBanner does not support the format ${placement == null ? void 0 : placement.format}`
    );
    return null;
  }
  const rendering = placement == null ? void 0 : placement.rendering;
  if (!rendering) {
    return null;
  }
  const imageSRC = isMobile ? getLocalizedCriteoRenderingValue(
    rendering,
    `mobile_background_image`,
    locale
  ) : getLocalizedCriteoRenderingValue(
    rendering,
    `desktop_background_image`,
    locale
  );
  if (!imageSRC) {
    return null;
  }
  const redirectURL = getLocalizedCriteoRenderingValue(
    rendering,
    `optional_footer_redirect_url`,
    locale
  ) || getLocalizedCriteoRenderingValue(rendering, `redirect_url`, locale);
  const MediaContainer = ({ children }) => {
    return /* @__PURE__ */ jsx(StyledInGridBannerMediaContainer, { children: redirectURL ? /* @__PURE__ */ jsx(Link, { href: redirectURL, children }) : /* @__PURE__ */ jsx(Fragment, { children }) });
  };
  const analyticsTitle = getLocalizedCriteoRenderingValue(
    rendering,
    `desktop_alt_text`,
    locale
  ) || getLocalizedCriteoRenderingValue(
    rendering,
    `desktop_background_image_alt_text`,
    locale
  );
  return /* @__PURE__ */ jsx(
    Observable,
    {
      observer: {
        minimumViewTime: analytics.minimumViewTime,
        onClick: analytics.onBannerClicked,
        onLoad: analytics.onCarouselRendered,
        onView: analytics.onCarouselViewed,
        viewThreshold: analytics.viewThreshold
      },
      sx: {
        display: "flex",
        width: "100%",
        ...sx
      },
      children: /* @__PURE__ */ jsx(
        Analytics,
        {
          analyticData: {
            adItem: {
              title: analyticsTitle
            }
          },
          children: /* @__PURE__ */ jsx(MediaContainer, { children: /* @__PURE__ */ jsx(
            GenericImageHandler,
            {
              alt: analyticsTitle,
              loading: "lazy",
              src: imageSRC
            }
          ) })
        }
      )
    }
  );
}
CriteoInGridBanner.displayName = COMPONENT_NAME;
export {
  CriteoInGridBanner
};
